"use client"

import { useT } from "./client"

/**
 * Tłumaczy tekst osadzony w JSX:  <T>Koszyk</T>
 *
 * Działa również wewnątrz komponentów SERWEROWYCH. To komponent kliencki,
 * a kontekst Reacta przechodzi przez granicę RSC — liczy się miejsce
 * w finalnym drzewie, a LangProvider opakowuje cały korzeń układu.
 * Dzięki temu nie trzeba zmieniać komponentów serwerowych na asynchroniczne
 * ani przepychać języka przez propsy.
 *
 * Do atrybutów (label, placeholder, title) używaj useT() — komponent
 * nie zwróci stringa.
 */
const T = ({ children }: { children: string }) => {
  const t = useT()
  return <>{t(children)}</>
}

export default T
